<template>
  <!-- Official badge from Google's brand assets when present in /public; neutral fallback otherwise. -->
  <button type="button" class="google-wallet-button" :class="{ 'google-wallet-button--badge': !badgeFailed }" :disabled="disabled" :aria-label="label" @click="$emit('click')">
    <span v-if="busy" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <img v-else-if="!badgeFailed" :src="badge" alt="" @error="badgeFailed = true">
    <span v-else class="google-wallet-fallback"><i class="fa-solid fa-wallet" aria-hidden="true"></i>{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'GoogleWalletButton',
  props: {
    disabled: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  emits: ['click'],
  data() {
    return {
      badgeFailed: false,
      badge: (process.env.BASE_URL || '/') + 'img/google-wallet/add-to-google-wallet-es.svg',
      label: 'Añadir a Google Wallet',
    };
  },
};
</script>

<style scoped>
.google-wallet-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  margin: 8px;
  padding: 0;
  border: 0;
  border-radius: 24px;
  background: #1f1f1f;
  color: #fff !important;
  -webkit-text-fill-color: #fff;
  cursor: pointer;
}
.google-wallet-button--badge { background: transparent; }
.google-wallet-button img { display: block; height: 48px; width: auto; }
.google-wallet-button:disabled { opacity: .6; cursor: default; }
.google-wallet-button .spinner-border { margin: 0 32px; color: #1f1f1f; }
.google-wallet-button:not(.google-wallet-button--badge) .spinner-border { color: #fff; }
.google-wallet-fallback { display: inline-flex; align-items: center; gap: 10px; padding: 0 20px; font-weight: 600; font-size: .95rem; }
</style>
